import React from 'react';
import { Mail, Zap, LinkedinIcon } from 'lucide-react';
import { FaXTwitter } from "react-icons/fa6";

// Button Component
const Button = ({ children, className, ...props }: any) => (
  <button 
    className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 ${className}`}
    {...props}
  >
    {children}
  </button>
);

// Header Component
const Header = () => (
  <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
    <div className="flex justify-between mx-auto max-w-7xl px-10 h-20">
      <a href="/" className="flex items-center gap-3">
        <div className="w-10 h-10 relative">
          <img src="/bsk-icon-v2.png" alt="Basilisk Logo" className="w-full h-full object-contain" />
        </div>
        <span className="text-2xl font-bold text-black">Basilisk</span>
      </a>
      <nav className="flex items-center gap-6">
        <a href="https://calendar.app.google/k8AR5Ya6LqkLWBJL7" target="_blank" rel="noopener noreferrer">
          <Button className="bg-gradient-to-r from-green-600 to-green-400 hover:from-green-500 hover:to-green-300 text-white font-bold px-8 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg">
            Schedule a Meeting
          </Button>
        </a>
      </nav>
    </div>
  </header>
);

// Footer Component
const Footer = () => (
  <footer className="mt-auto py-8 px-4 border-t border-gray-200 bg-white">
    <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center gap-6">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
            <Zap className="h-5 w-5 text-white" />
          </div>
          <span className="text-xl font-bold text-black">Basilisk</span>
        </div>
        <div className="flex gap-4">
          <a href="https://www.x.com/basilisk" className="hover:text-green-600 border border-gray-300 rounded-full p-2 flex items-center justify-center transition-colors" target="_blank" rel="noopener noreferrer">
            {FaXTwitter({ size: 20, className: "text-gray-600" })}
          </a>
          <a href="https://www.linkedin.com/company/the-liveops-guild/" className="hover:text-green-600 border border-gray-300 rounded-full p-2 flex items-center justify-center transition-colors" target="_blank" rel="noopener noreferrer">
            <LinkedinIcon size={20} className="text-gray-600" />
          </a>
        </div>
      </div>

      <div className="text-sm text-center text-gray-600">
        © Copyright {new Date().getFullYear()} Basilisk. All rights reserved.
      </div>

      <nav className="flex gap-6 text-sm whitespace-nowrap">
        <a href="/privacy/" className="hover:text-green-600 text-gray-600 transition-colors" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
        <a href="/terms/" className="hover:text-green-600 text-gray-600 transition-colors" target="_blank" rel="noopener noreferrer">
          Terms & Conditions
        </a>
      </nav>
    </div>
  </footer>
);

// Book Demo Page Component
const BookDemoPage = () => {
  return (
    <div className="antialiased">
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="container mx-auto py-12 md:py-24 relative overflow-hidden">
          <div className="max-w-3xl mx-auto relative z-10 text-center">
            <div className="inline-flex items-center gap-1 px-3 py-1 bg-[#342b19] text-green-300 rounded-full border border-[#413827] mb-6 w-fit mx-auto">
              <Mail size={16} />
              <p className="text-sm font-bold">Schedule a Meeting</p>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold uppercase mb-6">
              Ready to level up your game?
            </h1>
            <p className="text-md mb-8">
              Have questions? Need expert guidance on live operations? Whether you're looking to boost player engagement, optimize monetization, or future-proof your game, we're here to help. Reach out today and let's take your game to the next level!
            </p>
            <a href="https://calendar.app.google/k8AR5Ya6LqkLWBJL7" target="_blank" rel="noopener noreferrer">
              <Button className="bg-gradient-to-r from-green-600 to-green-400 hover:from-green-500 hover:to-green-300 text-white font-bold px-8 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 text-lg">
                Schedule a Meeting
              </Button>
            </a>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default BookDemoPage;
